import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "data-test-id", "ariaLabel", "animated"];
import classNames from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
/**
 * @trackcomponent
 */
export var LoadingSkeletonBase = function LoadingSkeletonBase(_ref) {
  var className = _ref.className,
    dataTestId = _ref["data-test-id"],
    ariaLabel = _ref.ariaLabel,
    _ref$animated = _ref.animated,
    animated = _ref$animated === void 0 ? true : _ref$animated,
    props = _objectWithoutProperties(_ref, _excluded);
  var _styles$rainbowSprink = styles.rainbowSprinkles(props),
    sprinklesClassName = _styles$rainbowSprink.className,
    style = _styles$rainbowSprink.style;
  return /*#__PURE__*/React.createElement("div", {
    role: "status",
    "aria-label": ariaLabel,
    "data-test-id": dataTestId,
    style: style,
    className: classNames(className, styles.container, sprinklesClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(className, styles.staticBackground, sprinklesClassName)
  }, animated ? (/*#__PURE__*/React.createElement("div", {
    className: classNames(className, styles.animatedBackground, sprinklesClassName)
  })) : null));
};